// src/constants/roles.js
export const ROLES = {
    USER: 'user',
    AGENT: 'agent',
    ADMIN: 'admin'
};

export const COMMISSION_RATE = 0.10; // 10% commission on deposits

export const DEPOSIT_STATUS = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected'
};

export const WITHDRAWAL_STATUS = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected'
};

export const TRADE_STATUS = {
    ACTIVE: 'active',
    CLOSED: 'closed'
};

export const TRADE_RESULT = {
    PROFIT: 'profit',
    LOSS: 'loss'
};
